import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { VIDEO_CTA_CLICKED } from 'constants/events';
import * as analytics from 'utilities/analytics';
import { goToNewTab } from 'utilities/url';

import { selectCtaConfig } from 'selectors/shareVideo';
import { selectCurrentUser } from 'selectors/user';
import { selectVideo, selectVideoPlayer } from 'selectors/videoPlayer';

import styles from './styles.module.less';

const CtaButton = props => {
  const { ctaMods, ctaUrl, ctaText } = useSelector(selectCtaConfig);
  const { size } = props;

  const fullUrl =
    ctaUrl && (ctaUrl.indexOf('http') > -1 ? ctaUrl : `//${ctaUrl}`);

  // TODO: Vlad: this is bad - but we are storing on the video that we want radius==4
  // we need to store something like "radius=medium" and map medium-->6px in our code
  function borderRadius() {
    if (ctaMods.border_radius === 4 || ctaMods.border_radius === undefined) {
      return 6;
    }

    return ctaMods.border_radius;
  }

  const customButtonStyles = {
    color: ctaMods.color,
    backgroundColor: ctaMods.background_color,
    borderRadius: `${borderRadius()}px`,
  };

  const videoPlayer = useSelector(selectVideoPlayer);
  const video = useSelector(selectVideo);
  const user = useSelector(selectCurrentUser);

  const handleClick = () => {
    goToNewTab(fullUrl);

    analytics.track(VIDEO_CTA_CLICKED, {
      from_public_share_page: videoPlayer.from_public_share_page,
      is_inline_embed_on_loom: videoPlayer.is_inline_embed_on_loom,
      parent_location: videoPlayer.parent_location,
      video_id: video.id,
      owner_id: video.owner_id,
      owner_click: video.owner_id === user.id,
    });
  };

  return (
    <button
      className={classNames(styles.ctaButton, {
        [styles.large]: size === 'large',
      })}
      onClick={handleClick}
      style={customButtonStyles}
    >
      {ctaText ? ctaText : 'Call-to-action'}
    </button>
  );
};

CtaButton.propTypes = {
  size: PropTypes.oneOf(['medium', 'large']),
};

CtaButton.defaultProps = {
  size: 'medium',
};

export default CtaButton;
